var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      ref: "playbutton",
      staticClass: "play-button",
      attrs: { id: "play-button--" + _vm.type },
      on: {
        click: function($event) {
          return _vm.clickHandler()
        }
      }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "observer",
              rawName: "v-observer",
              value: _vm.updateSize,
              expression: "updateSize"
            }
          ],
          staticClass: "wrapper",
          style: _vm.wrapper
        },
        [
          _c(
            "transition",
            { attrs: { name: "component", mode: "out-in" } },
            [
              _c(
                _vm.type,
                {
                  ref: "component",
                  tag: "component",
                  staticClass: "component",
                  class: { "has-label": _vm.label && _vm.type !== "loading" },
                  attrs: {
                    id: "play-button--" + _vm.type,
                    color: _vm.color,
                    label: _vm.label,
                    size: _vm.size / 2
                  }
                },
                [
                  _vm.label
                    ? _c(
                        "span",
                        { staticClass: "label", style: { color: _vm.color } },
                        [_vm._v(_vm._s(_vm.label))]
                      )
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }